import { FontType } from '@primitives/Typography/types';
import { switchSizeType } from './types';

export const switchSizeToLabelVariant: Record<switchSizeType, FontType> = {
    medium: 'p3',
    large: 'p2',
};
